
import { BaseStatusComponent } from "./status";
import { DemoStatusComponent } from "./status.demo";

import { mixin } from "@cems-eco/core/src/utils/platform";
import environment from "@/config";

export default class StatusComponent extends mixin(environment.nexus, {
  box: BaseStatusComponent,
  cloud: BaseStatusComponent,
  demo: DemoStatusComponent,
}) {
  [key: string]: any;
}
